module.exports = __webpack_public_path__ + "static/img/base_7.2c47b4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/base_7.jpg
// module id = +efP
// module chunks = 1